import React from 'react';
import { Menu, Responsive } from 'semantic-ui-react';
import NineDotMenu from './components/NineDotMenu';
import Cart from './components/Cart';
import MobileNineDotMenu from './components/MobileNineDotMenu';
import UserMenuSwapper from './components/UserMenuSwapper';
import DefaultHeader from './components/DefaultHeader';
import MobileMenu from './components/MobileMenu';
import MobileUserMenu from './components/MobileUserMenu';
import MobileContextMenu from './components/MobileContextMenu';

function AuthenticatedMenu(_ref) {
  var authUser = _ref.authUser,
      organisations = _ref.organisations,
      teams = _ref.teams,
      currentTeam = _ref.currentTeam,
      currentOrganisation = _ref.currentOrganisation,
      organisationChange = _ref.organisationChange,
      teamChange = _ref.teamChange,
      products = _ref.products,
      cartItems = _ref.cartItems,
      cartIcon = _ref.cartIcon,
      onlineStoreAccountURL = _ref.onlineStoreAccountURL,
      switchTo = _ref.switchTo,
      productFamilyId = _ref.productFamilyId,
      onToggleNavMenu = _ref.onToggleNavMenu,
      onMenuMouseOver = _ref.onMenuMouseOver,
      onMenuMouseLeave = _ref.onMenuMouseLeave,
      navMenuOpen = _ref.navMenuOpen,
      megaMenuOpen = _ref.megaMenuOpen,
      logoUrl = _ref.logoUrl,
      onNavigate = _ref.onNavigate,
      removeFromCart = _ref.removeFromCart,
      children = _ref.children,
      userMenuBreakpoint = _ref.userMenuBreakpoint,
      _ref$mobileBreakpoint = _ref.mobileBreakpoint,
      mobileBreakpoint = _ref$mobileBreakpoint === undefined ? 1000 : _ref$mobileBreakpoint;

  var HeaderRight = function HeaderRight() {
    return React.createElement(MobileNineDotMenu, {
      products: products
    });
  };

  var HeaderCenter = function HeaderCenter() {
    return React.createElement(DefaultHeader, {
      logoUrl: logoUrl,
      onNavigate: onNavigate,
      mobileBreakpoint: mobileBreakpoint
    });
  };

  var MobileDropdown = function MobileDropdown() {
    return React.createElement(React.Fragment, null, children);
  };

  var MobileFooter = function MobileFooter() {
    return React.createElement(React.Fragment, null, cartItems && React.createElement(Cart, {
      cartItems: cartItems,
      cartIcon: cartIcon,
      removeFromCart: removeFromCart,
      displayForMobile: true,
      onNavigate: onNavigate
    }), organisations && organisations.length > 0 ? React.createElement(MobileContextMenu, {
      contextType: 'Organisation',
      items: organisations,
      currentItem: currentOrganisation,
      handleItemChange: organisationChange
    }) : null, teams && teams.length > 0 ? React.createElement(MobileContextMenu, {
      contextType: 'Team',
      items: teams,
      currentItem: currentTeam,
      handleItemChange: teamChange
    }) : null, React.createElement(MobileUserMenu, {
      onNavigate: onNavigate,
      authUser: authUser,
      productFamilyId: productFamilyId
    }));
  };

  return React.createElement('div', {
    'data-testid': 'authenticated-menu'
  }, React.createElement(Responsive, {
    maxWidth: mobileBreakpoint,
    as: React.Fragment
  }, React.createElement(MobileMenu, {
    navMenuOpen: navMenuOpen,
    onToggleNavMenu: onToggleNavMenu,
    onNavigate: onNavigate,
    headerCenter: React.createElement(HeaderCenter, null),
    headerRight: React.createElement(HeaderRight, null),
    items: React.createElement(MobileDropdown, null),
    footer: React.createElement(MobileFooter, null)
  })), React.createElement(Responsive, {
    minWidth: mobileBreakpoint + 1,
    as: React.Fragment
  }, React.createElement(Menu, {
    borderless: true,
    stackable: true,
    fixed: 'top',
    onMouseOver: onMenuMouseOver,
    onFocus: onMenuMouseOver,
    onMouseLeave: onMenuMouseLeave,
    onBlur: onMenuMouseLeave,
    className: 'nav-menu nav-menu--small ' + (navMenuOpen ? 'nav-menu--open' : '') + ' ' + (megaMenuOpen ? 'nav-menu--mega-menu-open' : '')
  }, React.createElement(Menu.Item, {
    header: true,
    fitted: true,
    className: 'nav-menu__header'
  }, React.createElement(DefaultHeader, {
    onToggleNavMenu: onToggleNavMenu,
    logoUrl: logoUrl,
    onNavigate: onNavigate,
    mobileBreakpoint: mobileBreakpoint
  })), children, React.createElement(Menu.Menu, {
    position: 'right'
  }, cartItems && React.createElement(Cart, {
    cartItems: cartItems,
    cartIcon: cartIcon,
    removeFromCart: removeFromCart,
    displayForMobile: false
  }), React.createElement(Menu.Item, {
    as: UserMenuSwapper,
    organisations: organisations,
    userMenuBreakpoint: userMenuBreakpoint,
    currentOrganisation: currentOrganisation,
    teams: teams,
    currentTeam: currentTeam,
    organisationChange: organisationChange,
    teamChange: teamChange,
    authUser: authUser,
    onlineStoreAccountURL: onlineStoreAccountURL
  }), React.createElement(Menu.Item, {
    as: NineDotMenu,
    products: products,
    switchTo: switchTo
  })))));
}

export default AuthenticatedMenu;